import React, { useState } from "react"
import Header from "../Header/Header"
import { Sidebar } from "../Sidebar/Sidebar"


export const Layout = (props) => {
    
    const initialState = {
        isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    }
    const [state] = useState(initialState)

    const toggleMenuCallback = () => {
        var body = document.body;
        body.classList.toggle("vertical-collpsed");
        body.classList.toggle("sidebar-enable");
    }

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header
                    {...props.children.props}
                    toggleMenuCallback={toggleMenuCallback}
                />
                <Sidebar
                    isMobile={state.isMobile}
                />
                <div className="main-content" style={{ minHeight: '100vh' }}>{props.children}</div>
            </div>
        </React.Fragment>
    )

}
